export enum PaymentMethodType {
    paypal = 'paypal',
    card = 'card',
}
